module.exports = __webpack_public_path__ + "img/box7-3-3.d9027c5d.png";